

import React from "react";
import { Helmet } from "react-helmet";
import "./openingCeremony.css";
import Guest from "../../../assets/Blog/Guest.jpg";
import Corporate from "../../../assets/Blog/Corporate.jpg";
const BlogOpeningCeremony = () => {
  return (
    <>
      <Helmet>
        <title>
          Grand Opening Ceremony | Amaanat IVF & Fertility Centre
        </title>

        <meta
          name="description"
          content="Explore the memorable moments from the grand opening ceremony of Amaanat IVF & Test Tube Centre. A celebration of care, innovation, and commitment to fertility treatment excellence."
        />

        <meta
          name="keywords"
          content="Amaanat IVF opening ceremony, IVF centre inauguration, fertility clinic opening, IVF hospital Sonipat, fertility treatment India"
        />

        <meta name="author" content="Amaanat IVF" />

        {/* Open Graph SEO */}
        <meta
          property="og:title"
          content="Grand Opening Ceremony | Amaanat IVF"
        />

        <meta
          property="og:description"
          content="Take a glimpse into the inauguration ceremony of Amaanat IVF & Test Tube Centre."
        />

        <meta
          property="og:image"
          content="https://amaanativf.com/images/flower-welcome.jpg"
        />

        <meta
          property="og:url"
          content="https://amaanativf.com/blog/opening-ceremony"
        />

        <meta property="og:type" content="article" />

        {/* Twitter SEO */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Grand Opening Ceremony | Amaanat IVF"
        />

        <meta
          name="twitter:description"
          content="Celebrating the grand opening of Amaanat IVF & Test Tube Centre."
        />

        <meta
          name="twitter:image"
          content="https://yourdomain.com/images/flower-welcome.jpg"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://yourdomain.com/blog/opening-ceremony"
        />
      </Helmet>

      <div className="blog-container">
        
        {/* <div className="blog-hero">
          <img
            src={Corporate}
            alt="Amaanat IVF Opening Ceremony"
            className="hero-image"
          />

          <div className="hero-overlay">
            <span className="blog-category">EVENTS</span>

            <h1>
              Grand Opening Ceremony of Amaanat IVF & Test Tube Centre
            </h1>

            <p className="blog-date">
              Published on May 8, 2026 • By Amaanat IVF Team
            </p>
          </div>
        </div> */}

        {/* Blog Content */}
        <div className="blog-content">
          <p className="intro-text">
            Amaanat IVF & Fertility Centre proudly celebrated its grand opening
            ceremony with distinguished guests, medical professionals, staff
            members, and well-wishers. The event marked the beginning of a new
            journey dedicated to providing advanced fertility and reproductive
            healthcare services with compassion and excellence.
          </p>

          {/* Section 1 */}
          <section className="blog-section">
            <h2>Warm Welcome to Our Honorable Guests</h2>

            <p>
              The inauguration ceremony began with a heartfelt floral welcome
              for our honored guests and dignitaries. The atmosphere was filled
              with positivity, gratitude, and celebration as our team welcomed
              everyone with flowers and smiles.
            </p>

            <div className="blog-image-wrapper">
              <img
                src={Guest}
                alt="Welcoming guests with flowers at Amaanat IVF opening ceremony"
                className="blog-image"
              />
            </div>
          </section>

          {/* Section 2 */}
          <section className="blog-section">
            <h2>Meet Our Dedicated Team</h2>

            <p>
              Behind every successful healthcare institution is a passionate and
              hardworking team. Our experienced doctors, embryologists,
              counselors, nursing staff, and support members stand committed to
              helping families achieve their dream of parenthood.
            </p>

            <div className="blog-image-wrapper">
              <img
                src={Corporate}
                alt="Amaanat IVF staff group photo"
                className="blog-image"
              />
            </div>
          </section>

          {/* Quote */}
          <div className="quote-box">
            <p>
              “Every new beginning comes with hope, commitment, and the promise
              of better care.”
            </p>
          </div>

          {/* Conclusion */}
          <section className="blog-section">
            <h2>Beginning a New Journey of Hope</h2>

            <p>
              With state-of-the-art fertility technology and patient-centered
              care, Amaanat IVF aims to support couples through every step of
              their parenthood journey. The opening ceremony was not just an
              event — it was the start of countless success stories yet to come.
            </p>

            <p>
              We sincerely thank everyone who joined us and made this occasion
              memorable.
            </p>
          </section>

          {/* Tags */}
          <div className="blog-tags">
            <span>#AmaanatIVF</span>
            <span>#OpeningCeremony</span>
            <span>#IVFCentre</span>
            <span>#FertilityCare</span>
            <span>#Healthcare</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogOpeningCeremony;